<script>
import Socials from './SaleSocials';

export default {
  name: 'Header',
  components: { Socials },
  data: () => ({
    showVideo: false,
  }),
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    chain: {
      type: Boolean,
    },
  },
  methods: {
    getIconSrc() {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/img/${this.$chain.getName()}/launchpad/${this.product.icon}.jpg`);
    },
    getArrowSrc() {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/img/${this.$chain.getName()}/arrow.svg`);
    },
    getVideo() {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/video/${this.product.video}`);
    },
    openVideo() {
      this.showVideo = !this.showVideo;
    },
  },
};
</script>

<template>
  <div class="main-block mb-9 sale_header">
    <div class="upcoming-card__video" v-if="product.video">
      <video autoplay muted loop controls poster="@/assets/img/videoplaceholder.jpg">
        <source :src="getVideo()" type="video/mp4" />
      </video>
    </div>
    <div
      class="upcoming-card"
      :class="{
        'upcoming-card__fader--up': !showVideo && product.video,
        'upcoming-card__fader': product.video,
      }"
    >
      <div
        class="upcoming-card__fader-arrow"
        :class="{ 'upcoming-card__fader-arrow--upsidedown': !showVideo }"
        @click="openVideo"
        v-if="product.video"
      >
        <img :src="getArrowSrc()" alt="" />
      </div>
      <div class="d-flex justify-space-between mb-5">
        <div class="d-flex align-center flex-grow-1">
          <div class="upcoming-card__icon">
            <img :src="getIconSrc()" />
          </div>
          <div class="ml-5 d-block d-sm-flex justify-space-between flex-grow-1">
            <div>
              <div class="d-flex align-center mb-3 justify-end justify-sm-start">
                <span class="upcoming-card__title font-weight-bold mr-4">
                  {{ product.name }}
                </span>
              </div>
              <div class="footer__social justify-sm-start justify-end">
                <Socials
                  v-for="(social, index) in product.socialLinks"
                  :key="index"
                  :social="social"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-5">
        <p class="upcoming-card__disclaimer">
          {{ product.description }}
        </p>
        <div class="mt-10 text-center" v-if="!chain">
          <h1 class="upcoming-card__disclaimer">
            {{ $t('launchpad.switch') }}
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sale_header {
  overflow: hidden;
}

.upcoming-card {
  &__icon {
    body.binance & {
      color: $b-secondatry-font-color;
      background: $b-main-bg;
      box-shadow: $b-pools-select-shadow;
    }
  }

  &__step {
    body.binance & {
      color: $b-secondatry-font-color;
      background: $b-main-bg;
      box-shadow: $b-pools-select-shadow;
    }
  }

  &__countdown {
    body.binance & {
      color: $b-binance-color;
    }
  }

  &__video {
    border-top-left-radius: $main-item-border-radius;
    border-top-right-radius: $main-item-border-radius;
    overflow: hidden;

    video {
      width: 100%;
    }
  }

  &__fader {
    position: relative;
    background: $main-item-bg;
    box-shadow: $main-item-shadow;
    transition: all 500ms ease-in-out;

    body.binance & {
      background: $b-main-item-bg;
      box-shadow: none;
    }

    body.huobi & {
      background: $h-main-item-bg;
      box-shadow: none;
    }

    &--up {
      margin-top: -48rem;
      background: linear-gradient(180.94deg, transparent 0%, #fdfafb 17%, #f7fbfc 100.51%);

      body.binance & {
        background: linear-gradient(180deg, transparent 0%, #1a1a20 14%, #181822 100%);
      }

      body.huobi & {
      }
    }

    &-arrow {
      position: absolute;
      top: 1rem;
      left: Calc(50% - 1.5rem);
      cursor: pointer;

      img {
        width: 3rem;
      }

      &--upsidedown {
        transform: rotate(180deg);
        animation: UpDown 2s ease-in-out infinite;
      }
    }
  }
}

@keyframes UpDown {
  0%,
  100% {
    top: 1.5;
  }
  50% {
    top: 3.5rem;
  }
}
</style>
